package fr.frux.core.common.logging

internal actual fun platformWriteLog(
    level: LogLevel,
    tag: String,
    message: String,
    throwable: Throwable?,
) {
    println("${level.name} [$tag] $message ${throwable?.message ?: ""}".trimEnd())
}
